import { forwardRef, useMemo } from 'react'
import { EChart, type EChartHandle } from './EChart'
import { buildParetoOption, paretoRows, type ParetoInput, type ParetoItem } from './paretoOption'
import { useChartTheme } from './useChartTheme'

export interface ParetoProps extends ParetoInput {
  height?: number
  loading?: boolean
  ariaLabel?: string
  className?: string
  texture?: boolean
  onItemClick?: (item: ParetoItem) => void
}

/** Парето: доли и накопленная доля в % на одной оси, границы классов A/B/C. */
export const Pareto = forwardRef<EChartHandle, ParetoProps>(function Pareto(
  { height = 320, loading, ariaLabel, className, texture, onItemClick, ...input },
  ref,
) {
  const theme = useChartTheme()
  const rows = useMemo(() => paretoRows(input.items, input.thresholds), [input.items, input.thresholds])
  const option = useMemo(
    () => buildParetoOption(input, theme),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [theme, input.items, input.thresholds, input.valueFormat, input.classLabels],
  )
  return (
    <EChart
      ref={ref}
      option={option}
      height={height}
      loading={loading}
      ariaLabel={ariaLabel}
      className={className}
      texture={texture}
      onAxisClick={
        onItemClick
          ? (index) => {
              const row = rows[index]
              if (row) onItemClick(row.item)
            }
          : undefined
      }
    />
  )
})

export default Pareto
